import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/Users/csr/workspace/console-components/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/csr/workspace/console-components/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/csr/workspace/console-components/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/csr/workspace/console-components/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/csr/workspace/console-components/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es6.function.name";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import invariant from 'invariant';
import hoistStatics from 'hoist-non-react-statics';
import { DndContext, createDndContext } from '../common/DndContext';
import { checkDecoratorArguments, isRefable } from './utils';
/**
 * @deprecated Use DnDProvider in your JSX tree instead. This will be removed in a future major version.
 *
 * Wrap the root component of your application with DragDropContext decorator to set up React DnD.
 * This lets you specify the backend, and sets up the shared DnD state behind the scenes.
 * @param backendFactory The DnD backend factory
 * @param backendContext The backend context
 */

export function DragDropContext(backendFactory, backendContext, debugMode) {
  checkDecoratorArguments('DragDropContext', 'backend', backendFactory);
  var childContext = createDndContext(backendFactory, backendContext, debugMode);
  return function decorateContext(DecoratedComponent) {
    var Decorated = DecoratedComponent;
    var displayName = Decorated.displayName || Decorated.name || 'Component';

    var DragDropContextContainer = /*#__PURE__*/function (_React$Component) {
      _inherits(DragDropContextContainer, _React$Component);

      var _super = _createSuper(DragDropContextContainer);

      function DragDropContextContainer(props, context) {
        var _this;

        _classCallCheck(this, DragDropContextContainer);

        _this = _super.call(this, props, context);
        _this.ref = React.createRef();

        _this.getManager = function () {
          return childContext.dragDropManager;
        }; // eslint-disable-next-line no-console


        console.warn("DragDropContext has been deprecated and will be removed in a future version. Please use DndProvider instead.");
        return _this;
      }

      _createClass(DragDropContextContainer, [{
        key: "getDecoratedComponentInstance",
        value: function getDecoratedComponentInstance() {
          invariant(this.ref.current, 'In order to access an instance of the decorated component, it must either be a class component or use React.forwardRef()');
          return this.ref.current;
        }
      }, {
        key: "render",
        value: function render() {
          return React.createElement(DndContext.Provider, {
            value: childContext
          }, React.createElement(Decorated, Object.assign({}, this.props, {
            ref: isRefable(Decorated) ? this.ref : null
          })));
        }
      }]);

      return DragDropContextContainer;
    }(React.Component);

    DragDropContextContainer.DecoratedComponent = DecoratedComponent;
    DragDropContextContainer.displayName = "DragDropContext(".concat(displayName, ")");
    return hoistStatics(DragDropContextContainer, DecoratedComponent);
  };
}